import { TEMPLATE_TYPES } from '#constants/product';

export const isPreviewMode = mode => mode === 'preview';

export const isTemplateType = targetTemplateType => product =>
  product && product?.templateType && product.templateType === targetTemplateType;

export const isSingleCask = isTemplateType(TEMPLATE_TYPES.SINGLE_CASK);

export const isSingleMalt = isTemplateType(TEMPLATE_TYPES.SINGLE_MALT);

export const isLimitedRelease = isTemplateType(TEMPLATE_TYPES.LIMITED_RELEASE);
